import React, { useCallback, useRef } from 'react';
import Box from '@mui/material/Box';
import { AdminAreaLeftNavigation } from '../../areas/admin/components/admin-area-left-navigation';
import { AdminMenuLinkCollector, IAdminMenuLink, RegisterAdminMenuLink } from '../../areas/admin/components/admin-area-menu-links';
import { useAdminTabsIsAllowed } from '../../areas/admin/use-admin-tabs-is-allowed';
import { OmnibarEntry } from './omnibar-interfaces';
import { catalogCorrectionsToggle } from './utils/catalog-corrections';
import { administrationGroup } from './utils/context-filter';

export function adminMenuEntries(links: IAdminMenuLink[]): OmnibarEntry[] {
  const entries = new Map<string, OmnibarEntry>();
  links.forEach(({ label, to, onClick }) => {
    if (entries.has(label)) return;
    entries.set(label, {
      id: `admin:${to ?? label}`,
      label,
      keywords: ['administration'],
      context: 'none',
      group: administrationGroup,
      url: to,
      callbackFn: to ? undefined : onClick,
      featureToggleRequired: catalogCorrectionsToggle,
    });
  });
  return [...entries.values()];
}

export function OmnibarAdminLinks({ onChange }: { onChange: (links: IAdminMenuLink[]) => void }) {
  const tabsIsAllowed = useAdminTabsIsAllowed();
  const links = useRef(new Map<symbol, IAdminMenuLink>());
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const register = useCallback<RegisterAdminMenuLink>(link => {
    const key = Symbol(link.label);
    links.current.set(key, link);
    onChangeRef.current([...links.current.values()]);
    return () => {
      links.current.delete(key);
      onChangeRef.current([...links.current.values()]);
    };
  }, []);

  return (
    <Box sx={{ display: 'none' }} aria-hidden>
      <AdminMenuLinkCollector value={register}>
        <AdminAreaLeftNavigation {...tabsIsAllowed} />
      </AdminMenuLinkCollector>
    </Box>
  );
}
